import React from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

import { EButton } from "..";

interface EPaginationProps {
    goToNextPage: () => void;
    goToPreviousPage: () => void;
    count?: string;
    isLoading: boolean;
    disablePrev: boolean;
    disableNext: boolean;
}

export const EPagination: React.FC<EPaginationProps> = ({
    goToNextPage,
    goToPreviousPage,
    count,
    isLoading,
    disablePrev,
    disableNext,
}) => {
    return (
        <div className="flex flex-row items-center justify-end">
            {count ? (
                <p className="text-xs font-semibold text-textSecondary/60 flex flex-1">
                    {count} items found
                </p>
            ) : <></>}

            <div className="flex gap-2 justify-end mt-2">
                <EButton
                    size="sm"
                    variant="outline"
                    onClick={goToPreviousPage}
                    loading={isLoading}
                    disabled={disablePrev}
                >
                    <FiChevronLeft size={20} /> Prev
                </EButton>
                <EButton
                    size="sm"
                    variant="outline"
                    onClick={goToNextPage}
                    loading={isLoading}
                    disabled={disableNext}
                >
                    Next <FiChevronRight size={20} />
                </EButton>
            </div>
        </div>
    );
};